import { Button } from './Button'
import './foot.css'

export type FootAction = {
  label: string
  disabled?: boolean
  onSelect: () => void
}

/**
 * The two buttons that close a surface: the secondary leading, the primary
 * trailing it. The one drawing of them, so a sheet, a modal and a flow set
 * inside a page put the same two answers in the same two places.
 *
 * `trail` sets the pair together at the trailing edge, as a dialog's answer
 * sits; without it the primary takes the rest of the row, as a sheet's commit
 * finishes its column.
 */
export function Foot({
  primary,
  secondary,
  trail = false,
  className,
}: {
  primary?: FootAction
  secondary?: FootAction
  trail?: boolean
  className?: string
}) {
  const lead = secondary ? (
    <Button
      variant="secondary"
      className={trail ? undefined : 'uifoot__lead'}
      disabled={secondary.disabled}
      onClick={secondary.onSelect}
    >
      {secondary.label}
    </Button>
  ) : null
  const commit = primary ? (
    <Button disabled={primary.disabled} onClick={primary.onSelect}>
      {primary.label}
    </Button>
  ) : null
  return (
    <footer
      className={`uifoot${!trail && lead ? ' uifoot--pair' : ''}${className ? ` ${className}` : ''}`}
    >
      {trail ? (
        <span className="uifoot__end">
          {lead}
          {commit}
        </span>
      ) : (
        <>
          {lead}
          {commit ? <span className="uifoot__end">{commit}</span> : null}
        </>
      )}
    </footer>
  )
}
